"use client";
import { LicenseScopeDescription } from "@/features/platform-license/LicenseScopeDescription";
import { DocumentBody } from "@/features/service-information/DocumentBody";
import { agreement, fillAgreementAppendix, personalizeAgreement } from "../agreement-document";
import type { AuthorizationScope } from "../authorization-scope";
import type { AgreementChoices } from "../agreement-choices";

export function ProjectAgreementChoices({ scope, buyer, usage, term, amountMinor }: {
  scope?: AuthorizationScope; usage?: string; term?: string; amountMinor?: number;
  buyer?: { companyName: string; creditCode?: string; creditCodeLast4?: string | null };
  choices: AgreementChoices; onChange: (choices: AgreementChoices) => void;
}) {
  const personalized = personalizeAgreement(agreement.blocks, { ...buyer, amountMinor });
  return <DocumentBody blocks={scope ? fillAgreementAppendix(personalized, scope, { usage, term }) : personalized} renderRuns={runs =>
    runs.map(run => run.text).join("") === "详见《数字形象授权范围说明》" ? <>详见<LicenseScopeDescription /></> : undefined} />;
}
